<!-- The template is to be overridden by the child component with component inheritance -->
<cinematic (onClose)="handleClose()"></cinematic>
